module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADmwAAA5sBPN8HMQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADgSURBVGiB7dnBCoJAEIDhsRcMMiiIsmO+ddgl6ObRtL9DQrDSwSXc2WH+oweZDxXdVcTz9ATsgRa4AWXqeaICCuDBtx44pJ4rqgCSLwbYjcObwJRAF2BeQJ16ttk5RmvA1jEac4zWRszTMdpyjNYcozXHaM0apgKGANOT4x7AD0wTc67Vv4ebWSsiQ3CsSDFIdMCG6cdlXrcWcGS6edE5YumsIE6O0JAVRGUFEb61HbF4VhBnC4gLnzWFI5JmBVE7QkN8FkX5/wwFmuwRIiLAPXuEiAiwHq/KNatnwvPm9wY8ZUsSbCu40QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/next-arrow50.png
// module id = 479
// module chunks = 3